import React, { useEffect, useState, useContext } from 'react';
import { Grid, FormLabel, FormHelperText, CircularProgress, Typography, FormControlLabel, Checkbox, InputLabel } from '@material-ui/core';
import { SecondaryButton, TextBox, YesNoButton, SingelSelect, SelectBox, CustomColorPicker } from '../../../../Core/FormInput';
import AppContext from '../../../../App/AppContext';
import { getTCardJobTypesByID, postTCardJobTypes } from '../../../../Core/Service/t-card-JobStatus-service';
import { SketchPicker } from 'react-color';
import CustomeEditor from '../../../../Core/CkEditor';
import { getWorkflows } from '../../../../Core/Service/workflow-service';

const UpdateJobStatusModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [dropdownLists, setDropdownLists] = useState({
        workflows: []
    });
    const [state, setState] = useState({
        tCardStatusDescription: '',
        tCardStatusMessage: '',
        tCardStatusSMSText: '',
        tCardStatusSubject: '',
        tCardStatusequence: '',
        tCardStatusTextColour: '#000000',
        tCardStatusBackGroundColour: '#ffffff',
        tCardStatusIgnoreStatusColours: false,
        tCardStatusBody: '',
        tCardStatusIsActive: false,
        dropdownOptions: [],
        errors: {}
    });

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // Always fetch workflows
                const workflowsRes = await getWorkflows();

                setDropdownLists((dl) => ({
                    ...dl,
                    workflows:
                        workflowsRes?.data?.map((q) => ({
                            id: q.id,
                            name: q.workflowName
                        })) || []
                }));

                // Fetch job status only if updating
                if (props.isUpdate) {
                    const jobStatusRes = await getTCardJobTypesByID(props.jobStatusID);
                    const data = jobStatusRes?.data?.list?.table[0] || {};

                    if (jobStatusRes.success) {
                        setState((st) => ({
                            ...st,
                            tCardStatusDescription: data.tCardStatusDescription,
                            tCardStatusMessage: data.tCardStatusMessage,
                            tCardStatusSMSText: data.tCardStatusSMSText,
                            tCardStatusSubject: data.tCardStatusSubject,
                            tCardStatusBody: data.tCardStatusBody,
                            tCardStatusIsActive: data.tCardStatusIsActive,
                            tCardStatusequence: data.tCardStatusequence,
                            tCardStatusTextColour: data.tCardStatusTextColour || '#000000',
                            tCardStatusBackGroundColour: data.tCardStatusBackGroundColour || '#ffffff',
                            tCardStatusIgnoreStatusColours: data.tCardStatusIgnoreStatusColours || false,
                            tCardStatusMovedToWorkflowID: data.tCardStatusMovedToWorkflowID || '',
                            errors: {}
                        }));
                    }
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [props.jobStatusID, props.isUpdate]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value,
            errors: { ...st.errors, [name]: '' }
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!state.tCardStatusDescription) {
            formIsValid = false;
            errors.tCardStatusDescription = 'Description is required.';
        }
        // if (!state.tCardStatusMessage) {
        //     formIsValid = false;
        //     errors.tCardStatusMessage = 'Message is required.';
        // }
        if (state.tCardStatusequence === '') {
            formIsValid = false;
            errors.tCardStatusequence = 'Sequence is required.';
        }

        setState((st) => ({
            ...st,
            errors: errors
        }));

        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setLoading(true);
            try {
                const data = {
                    tCardStatusID: props.isUpdate ? props.jobStatusID : null,
                    tCardStatusDescription: state.tCardStatusDescription,
                    tCardStatusMessage: state.tCardStatusMessage,
                    tCardStatusSMSText: state.tCardStatusSMSText,
                    tCardStatusSubject: state.tCardStatusSubject,
                    tCardStatusBody: state.tCardStatusBody,
                    tCardStatusIsActive: state.tCardStatusIsActive,
                    tCardStatusequence: state.tCardStatusequence,
                    tCardStatusTextColour: state.tCardStatusTextColour,
                    tCardStatusBackGroundColour: state.tCardStatusBackGroundColour,
                    tCardStatusIgnoreStatusColours: state.tCardStatusIgnoreStatusColours,
                    tCardStatusMovedToWorkflowID: state.tCardStatusMovedToWorkflowID
                };
                let res = await postTCardJobTypes(data);
                if (res.data.success) {
                    showToast(`Job Status ${props.isUpdate ? 'Updated' : 'Added'} successfully`);
                    props.onClose(true);
                } else {
                    console.error(res.message);
                }
            } catch (error) {
                console.error('Error submitting data:', error);
            } finally {
                setLoading(false);
            }
        }
    };
    const handleCkeditorstate = (name) => (event, editor) => {
        const data = editor.getData();
        setState((st) => ({ ...st, [name]: data }));
    };
    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        setState((st) => {
            const nst = { ...st };
            nst[name] = checked;
            return nst;
        });
    };
    const handleClick = (name, value) => {
        setState((st) => {
            const nst = { ...st, [name]: value };
            return nst;
        });
    };
    return (
        <div>
            {loading ? (
                <div style={{ margin: '325px 270px' }}>
                    <CircularProgress />
                    <Typography style={{ fontWeight: 'bold' }}>Loading...</Typography>
                </div>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel className="mandatoryfields" required>
                            Description
                        </FormLabel>
                        <TextBox onChange={handleInput} value={state.tCardStatusDescription} name="tCardStatusDescription" />
                        {state.errors.tCardStatusDescription && (
                            <FormHelperText className="mandatoryfields">{state.errors.tCardStatusDescription}</FormHelperText>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel className="mandatoryfields" required>
                            Sequence
                        </FormLabel>
                        <TextBox onChange={handleInput} value={state.tCardStatusequence} name="tCardStatusequence" />
                        {state.errors.tCardStatusequence && <FormHelperText className="mandatoryfields">{state.errors.tCardStatusequence}</FormHelperText>}
                    </Grid>
                    <Grid item container spacing={2} xs={12} sm={6} style={{ marginTop: 0 }}>
                        {/* <Grid item xs={12} sm={12}> */}
                        <FormLabel style={{ textAlign: 'center', paddingLeft: 10 }}>
                            <b>Colour Text / Background</b>
                        </FormLabel>
                        {/* </Grid> */}
                        <Grid item xs={6} sm={6}>
                            <CustomColorPicker
                                color={state.tCardStatusTextColour}
                                onChange={(color) => setState((st) => ({ ...st, tCardStatusTextColour: color.hex }))}
                                width="100%"
                            />
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <CustomColorPicker
                                color={state.tCardStatusBackGroundColour}
                                onChange={(color) => setState((st) => ({ ...st, tCardStatusBackGroundColour: color.hex }))}
                                width="100%"
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6} style={{ paddingLeft: 23 }}>
                        <FormLabel style={{ textAlign: 'center' }}>
                            <b>Ignore Status Colour?</b>
                        </FormLabel>
                        <YesNoButton
                            style={{ marginBottom: '5px' }}
                            state={state.tCardStatusIgnoreStatusColours}
                            name="tCardStatusIgnoreStatusColours"
                            onYesClick={() => handleClick('tCardStatusIgnoreStatusColours', true)}
                            onNoClick={() => handleClick('tCardStatusIgnoreStatusColours', false)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel style={{ marginBottom: '8px' }}>Moved To Workflow</InputLabel>
                        <SelectBox
                            List={dropdownLists.workflows}
                            name="tCardStatusMovedToWorkflowID"
                            value={state.tCardStatusMovedToWorkflowID}
                            onChange={handleInput}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel>Status SMS Text</FormLabel>
                        <TextBox onChange={handleInput} value={state.tCardStatusSMSText} name="tCardStatusSMSText" />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel>Email Message</FormLabel>
                        <TextBox onChange={handleInput} value={state.tCardStatusMessage} name="tCardStatusMessage" />
                        {/* {state.errors.tCardStatusMessage && <FormHelperText className="mandatoryfields">{state.errors.tCardStatusMessage}</FormHelperText>} */}
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel>Email Subject</FormLabel>
                        <TextBox onChange={handleInput} value={state.tCardStatusSubject} name="tCardStatusSubject" />
                        {state.errors.tCardStatusSubject && <FormHelperText className="mandatoryfields">{state.errors.tCardStatusSubject}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <FormLabel>Email Body</FormLabel>
                        <br />

                        <CustomeEditor
                            data={state.tCardStatusBody}
                            onChange={handleCkeditorstate('tCardStatusBody')}
                            placeholder="Add description here"
                            name="tCardStatusBody"
                        />
                    </Grid>
                    <Grid item md={12}>
                        <FormControlLabel
                            control={<Checkbox checked={state.tCardStatusIsActive} onChange={handleCheckbox} name="tCardStatusIsActive" />}
                            label="Is Active?"
                        />
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 20, marginBottom: 15 }}>
                        <SecondaryButton fullWidth onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default UpdateJobStatusModal;
